export const obtenerValorTotal = (entidad) => {

    console.log(entidad)

    let tarifa = entidad.tarifa ? parseInt(entidad.tarifa) : 0
    let tarifaNinos = entidad.tarifaNinos ? parseInt(entidad.tarifaNinos) : 0
    let tarifaAcompanante = entidad.tarifaAcompanante ? parseInt(entidad.tarifaAcompanante) : 0
    let adicionales = entidad.adicionales ? totalArr(entidad.adicionales) : 0
    let descuentos = entidad.descuentos ? totalArr(entidad.descuentos) : 0
    let numNoches = entidad.numNoches ? entidad.numNoches : 0
    let numAcompanantes = entidad.numAcompanantes ? entidad.numAcompanantes : 0
    let numNinos = entidad.numNinos ? entidad.numNinos : 0

    return (tarifa * numNoches) + (tarifaNinos * numNinos * numNoches) + (tarifaAcompanante * numAcompanantes * numNoches) + adicionales - descuentos

}

export const totalArr = (arr=[]) => {

    let total = 0
    for (let i = 0; i < arr.length; i++) {
        total += parseInt(arr[i].valor)
    }

    return total
}